import React from 'react'

import { InviteButton } from '@components/RailsViewButtons/InviteButton'
import { Card, CardHeading, CardContent } from '@components/layout/Card'

export const InviteCard = ({ referralsPath }) => {
  return (
    <Card className='flex flex-col'>
      <CardHeading className='text-center'>
        <h5 className='mb-0'>Empower your friends and family</h5>
        <p>Invite the people you care about to take control of their future</p>
      </CardHeading>
      <CardContent className='flex flex-col gap-4'>
          <InviteButton fullWidth referralsPath={referralsPath} />
      </CardContent>
    </Card>
  )
}
